export enum CURRENCY_MODES {
  ABC = 'ABC',
  PBC = 'PBC',
  GENERAL = 'GENERAL',
}

export const AbcRegExp = /.*Abc$/;
export const PbcRegExp = /.*Pbc$/;
